// convert minutes duration to xx hr xx min
export function formatDuration(minutes){

    var totalMinutes = minutes;
    var hours = Math.floor(totalMinutes / 60);          
    var minutes = totalMinutes % 60;

    return `${hours ? `${hours} hr ` : ''}${minutes ? `${minutes} min` : ''}`
};

// convert 24 hours to 12 hours format
export function convertTo12HourFormat(time) {
    // Split the time string into hours and minutes
    const [hours, mins] = time.split(':');

    // Convert hours and minutes to numbers
    const hoursNum = parseInt(hours);
    const minsNum = parseInt(mins);

    // Convert hours to 12-hour format
    let formattedHours = hoursNum % 12;
    formattedHours = formattedHours === 0 ? 12 : formattedHours; // Handle midnight (00:00)

    // Determine if it's AM or PM
    const period = hoursNum >= 12 ? 'PM' : 'AM';

    // Format the time
    const formattedTime = `${formattedHours}:${String(minsNum).padStart(2, '0')} ${period}`;

    return formattedTime;
};

// generate time format by adding minutes to time format
// eg, time = "22:00" and minutes is "40" the function will return "22:40"
// this function is used in "src/screens/Parents/ScheduleBooking.jsx"
export function addMinutes(time, minutes) {
    // Split the time string into hours and minutes
    const [hours, mins] = time.split(':');
    
    // Convert hours and minutes to numbers
    const startHours = parseInt(hours);
    const startMins = parseInt(mins);

    // Create a new Date object with the given time
    const startTime = new Date();
    startTime.setHours(startHours);
    startTime.setMinutes(startMins);

    // Add the duration (in minutes) to the start time
    startTime.setMinutes(startTime.getMinutes() + minutes);

    // Format the end time
    const endTime = `${String(startTime.getHours()).padStart(2, '0')}:${String(startTime.getMinutes()).padStart(2, '0')}`;
    
    return endTime;
}